import { useState } from 'react'
import {
  Plus,
  Users,
  FolderKanban,
  CheckSquare,
  RefreshCw,
  X,
} from 'lucide-react'

interface ActionButtonsProps {
  onCreatePerson: () => void
  onCreateProject: () => void
  onCreateTask: () => void
  onRefresh: () => void
  isLoading: boolean
}

export default function ActionButtons({
  onCreatePerson,
  onCreateProject,
  onCreateTask,
  onRefresh,
  isLoading,
}: ActionButtonsProps) {
  const [isExpanded, setIsExpanded] = useState(false)

  const actions = [
    { icon: Users, label: 'Person', onClick: onCreatePerson, color: '#60a5fa' },
    { icon: FolderKanban, label: 'Project', onClick: onCreateProject, color: '#fbbf24' },
    { icon: CheckSquare, label: 'Task', onClick: onCreateTask, color: '#f87171' },
  ]

  return (
    <>
      {isExpanded && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
          onClick={() => setIsExpanded(false)}
        />
      )}

      <div className="fixed bottom-6 right-6 z-50 flex flex-col-reverse items-end gap-3">
        {isExpanded && (
          <div className="flex flex-col-reverse gap-2 mb-2 animate-in fade-in slide-in-from-bottom-4 duration-200">
            {actions.map((action, index) => (
              <button
                key={action.label}
                onClick={() => {
                  action.onClick()
                  setIsExpanded(false)
                }}
                className="flex items-center gap-3 px-4 py-3 bg-gray-900 border border-gray-800 rounded-full hover:bg-gray-800 transition-colors"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <action.icon size={20} style={{ color: action.color }} />
                <span className="text-sm text-white">{action.label}</span>
              </button>
            ))}

            <button
              onClick={() => {
                onRefresh()
                setIsExpanded(false)
              }}
              disabled={isLoading}
              className="flex items-center gap-3 px-4 py-3 bg-gray-900 border border-gray-800 rounded-full hover:bg-gray-800 transition-colors disabled:opacity-50"
            >
              <RefreshCw size={20} className={`text-gray-400 ${isLoading ? 'animate-spin' : ''}`} />
              <span className="text-sm text-white">Refresh</span>
            </button>
          </div>
        )}

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={`w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 ${
            isExpanded
              ? 'bg-gray-800 rotate-45'
              : 'bg-white hover:bg-gray-200'
          }`}
        >
          {isExpanded ? (
            <X size={24} className="text-white" />
          ) : (
            <Plus size={24} className="text-black" />
          )}
        </button>
      </div>
    </>
  )
}
